module.exports = __webpack_public_path__ + "static/media/conffeti-bg.f78f43bf.png";